import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { map, Observable, startWith, switchMap } from 'rxjs';

import { fallbackLanguage } from '@valk-nx/core/lib/core';
import { ContentHotelInterface } from '@valk-nx/core/lib/interfaces/hotels.interface';
import { AvailabilityWidgetComponent } from '@valk-nx/storyblok/components/availability-widget/src/lib/availability-widget';
import { CarouselComponent } from '@valk-nx/storyblok/components/carousel/src/lib/carousel';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { ContentService } from '@valk-nx/storyblok-services/src/lib/services/content.service';
import { HotelStore } from '@valk-nx/storyblok-store/src/lib/store/hotel/hotel.store';
import { Carousel } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-carousel-with-availability-widget',
	templateUrl: './carousel-with-availability-widget.html',
	imports: [
		CommonModule,
		CarouselComponent,
		AvailabilityWidgetComponent,
		StoryblokDirective,
	],
})
export class CarouselWithAvailabilityWidgetComponent extends StoryblokRootDirective {
	private readonly translate = inject(TranslateService);
	private readonly contentService = inject(ContentService);
	readonly currentLanguage = signal<string>(fallbackLanguage);
	readonly hotelStore = inject(HotelStore);

	blocks = input<Carousel[]>([]);
	hotelGUID = input<string | undefined>(undefined);
	hotelSlug = input<string | undefined>(undefined);
	openInNewTab = input<boolean>(false);

	readonly carousel = computed(() =>
		this.blocks().find((x) => x.component === 'carousel'),
	);

	readonly hotel$: Observable<ContentHotelInterface> =
		this.translate.onLangChange.pipe(
			startWith({ lang: this.translate.getCurrentLang() }),
			switchMap((event) => this.contentService.getHotelInfo(event.lang)),
			map((response) => response.data),
		);

	constructor() {
		super();
		this.currentLanguage.set(
			this.translate.getCurrentLang() ?? this.translate.getFallbackLang(),
		);
	}
}
